import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button } from 'components/ui/button';

import { showMergeRecordsModal } from '../../store/actions/properties';
import { getSelectedPropertyIds } from '../../store/selectors/select_list';

const minRecordsForMerge = 2;
const maxRecordsForMerge = 5;

export class MergeButton extends React.Component {
  static propTypes = {
    selectedIds: PropTypes.array.isRequired,
    showMergeModal: PropTypes.func.isRequired
  };

  canMerge() {
    const { selectedIds } = this.props;
    return selectedIds.length >= minRecordsForMerge && selectedIds.length <= maxRecordsForMerge;
  }

  handleMergeProperties = () => {
    this.props.showMergeModal();
  };

  render() {
    return (
      <Button
        disabled={!this.canMerge()}
        name="merge-button"
        onClick={this.handleMergeProperties}
      >
        Merge Properties
      </Button>
    );
  }
}

const mapStateToProps = state => ({
  selectedIds: getSelectedPropertyIds(state)
});

const mapDispatchToProps = {
  showMergeModal: showMergeRecordsModal
};

export default connect(mapStateToProps, mapDispatchToProps)(MergeButton);
